import React, { useCallback, useEffect, useRef, useState } from "react";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { IUbicacionRequest } from "../../../Interfaces/auxiliar/IUbicacion";
import UbicacionService from "../../../services/auxiliar/UbicacionService";

interface UbicacionProps {
    // nivel: number;
    isOpen: boolean;
    comboNivel: number
}

const UseComboUbicacion = ({ comboNivel = 0, isOpen }: UbicacionProps) => {
    const controllerRef = useRef<AbortController>(new AbortController());
    const [filterCombo, setFilterCombo] = useState<IUbicacionRequest>({
        skip: 0,
        take: 20,
        nivel: comboNivel,
        search:""
    });
    const [dataComboUbicacion, setDataComboUbicacion] = useState<IComboBoxOption[]>([]);

    const comboBoxRefUbicacion = useRef<IComboBox>(null);
    const onClickComboUbicacion = () => comboBoxRefUbicacion.current?.focus(true);

    const onChangeUbicacion = (value:any) => {
        setFilterCombo({ ...filterCombo, search: value });
    }
   
    const _onkeyUpSearchUbicacion = (event: React.KeyboardEvent<IComboBox>) => {
        if (event.code === "Escape") {
            comboBoxRefUbicacion.current?.focus(false);
            setFilterCombo({
                skip: 0,
                take: 20,
                nivel: comboNivel
            });
        } else {
            let { value } = event?.target as HTMLInputElement;
            setFilterCombo({ ...filterCombo, search: value });
        }
    };

    const listarCombo = () => {
        controllerRef.current.abort();
        const newController = new AbortController();
        controllerRef.current = newController;
        UbicacionService.ComboUbicacion(filterCombo).then((res) => {
            if (res.status === 200) {
                setDataComboUbicacion(res.data);
            }
        });
    };

    useEffect(() => {
        if (isOpen) {
            listarCombo();
        }
    }, [isOpen]);
    
    useEffect(()=>{
        if(filterCombo.search!=""){
           listarCombo()
        }
    },[filterCombo.search])

    return {
        dataComboUbicacion,
        onClickComboUbicacion,
        _onkeyUpSearchUbicacion,
        comboBoxRefUbicacion,
        filterCombo,
        setFilterCombo,
        onChangeUbicacion,
    };
}

export { UseComboUbicacion }
